import React, { lazy } from 'react';
import { GiftIcon, SparklesIcon } from 'lucide-react';
export function BonusSection() {
  return <section className="w-full bg-gradient-to-b from-white to-emerald-50 py-16 md:py-24" data-id="element-77">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-78">
        <div className="text-center mb-12" data-id="element-79">
          <div className="flex items-center justify-center gap-3 mb-4" data-id="element-80">
            <GiftIcon className="w-10 h-10 text-emerald-700" data-id="element-81" />
            <SparklesIcon className="w-8 h-8 text-emerald-700" data-id="element-82" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-stone-900 mb-4" data-id="element-83">
            Bonuses Included With Purchase
          </h2>
          <p className="text-xl text-stone-700" data-id="element-84">
            Get these valuable bonuses absolutely FREE today
          </p>
        </div>
        <div className="grid md:grid-cols-2 gap-8 mb-8" data-id="element-85">
          <div className="bg-white rounded-xl shadow-lg overflow-hidden" data-id="element-86">
            <div className="aspect-square overflow-hidden" data-id="element-87">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/3PFrCW8Kb7W88EKaBKbHtC/3-day-Herbal_Detox_and_Refreshment_Essentials.png" alt="The 3-Day Herbal Detox Plan" className="w-full h-full object-cover" loading="lazy" data-id="element-88" />
            </div>
            <div className="p-6" data-id="element-89">
              <div className="flex items-center justify-between mb-3" data-id="element-90">
                <h3 className="text-2xl font-bold text-stone-900" data-id="element-91">Bonus #1</h3>
                <span className="bg-emerald-100 text-emerald-700 px-3 py-1 rounded-full text-sm font-semibold" data-id="element-92">
                  Value: $17
                </span>
              </div>
              <h4 className="text-xl font-semibold text-stone-900 mb-3" data-id="element-93">
                The 3-Day Herbal Detox Plan
              </h4>
              <p className="text-stone-700 mb-4" data-id="element-94">
                A simple, 3-day cleanse to reset your body naturally
              </p>
              <ul className="space-y-2 text-stone-600" data-id="element-95">
                <li className="flex items-start gap-2" data-id="element-96">
                  <span className="text-emerald-700 font-bold" data-id="element-97">✓</span>
                  <span data-id="element-98">
                    Focuses on liver support, bloating reduction, and energy
                    restoration
                  </span>
                </li>
                <li className="flex items-start gap-2" data-id="element-99">
                  <span className="text-emerald-700 font-bold" data-id="element-100">✓</span>
                  <span data-id="element-101">
                    Includes daily schedules, herbal teas, soups, and detox
                    baths
                  </span>
                </li>
                <li className="flex items-start gap-2" data-id="element-102">
                  <span className="text-emerald-700 font-bold" data-id="element-103">✓</span>
                  <span data-id="element-104">Visual + printable format</span>
                </li>
              </ul>
            </div>
          </div>
          <div className="bg-white rounded-xl shadow-lg overflow-hidden" data-id="element-105">
            <div className="aspect-square overflow-hidden" data-id="element-106">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/43WyyBu7hhxchs7nvLtV9u/Herbal_Healing_in_a_Rustic_Kitchen.png" alt="The Herbal Healing Recipes Collection" className="w-full h-full object-cover" loading="lazy" data-id="element-107" />
            </div>
            <div className="p-6" data-id="element-108">
              <div className="flex items-center justify-between mb-3" data-id="element-109">
                <h3 className="text-2xl font-bold text-stone-900" data-id="element-110">Bonus #2</h3>
                <span className="bg-emerald-100 text-emerald-700 px-3 py-1 rounded-full text-sm font-semibold" data-id="element-111">
                  Value: $17
                </span>
              </div>
              <h4 className="text-xl font-semibold text-stone-900 mb-3" data-id="element-112">
                The Herbal Healing Recipes Collection
              </h4>
              <p className="text-stone-700 mb-4" data-id="element-113">
                40+ recipes to support your health naturally
              </p>
              <ul className="space-y-2 text-stone-600" data-id="element-114">
                <li className="flex items-start gap-2" data-id="element-115">
                  <span className="text-emerald-700 font-bold" data-id="element-116">✓</span>
                  <span data-id="element-117">
                    Immune shots, herbal teas, infused oils & tinctures
                  </span>
                </li>
                <li className="flex items-start gap-2" data-id="element-118">
                  <span className="text-emerald-700 font-bold" data-id="element-119">✓</span>
                  <span data-id="element-120">DIY syrups, cough remedies, and skin care recipes</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-121">
                  <span className="text-emerald-700 font-bold" data-id="element-122">✓</span>
                  <span data-id="element-123">
                    Beautifully formatted with imagery as your kitchen companion
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="bg-emerald-700 text-white rounded-xl p-8 text-center" data-id="element-124">
          <p className="text-3xl font-bold mb-2" data-id="element-125">
            Total Bonus Value:{' '}
            <span className="relative inline-block px-1" data-id="element-126">
              <span className="relative z-10" data-id="element-127">$34</span>
              <span className="absolute left-0 right-0 top-1/2 -translate-y-1/2" style={{
              transform: 'translateY(-50%) rotate(-20deg)',
              transformOrigin: 'center'
            }} data-id="element-128">
                <span className="block w-full h-0.5 bg-white" data-id="element-129"></span>
              </span>
            </span>
          </p>
          <div className="flex items-center justify-center gap-2" data-id="element-130">
            <SparklesIcon className="w-6 h-6 text-emerald-200" data-id="element-131" />
            <p className="text-2xl" data-id="element-132">
              Yours <span className="font-bold" data-id="element-133">FREE</span> Today!
            </p>
            <SparklesIcon className="w-6 h-6 text-emerald-200" data-id="element-134" />
          </div>
        </div>
      </div>
    </section>;
}